export default __webpack_public_path__ + "static/media/schulte-mix.cd804ed6.svg";